import Spritesheet from 'react-responsive-spritesheet';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';

export type UseSpriteSheetProps = {
  name: string;
  ref: any;
  [key: string]: any;
};
export function useSpriteSheet({ name, ref, ...rest }: UseSpriteSheetProps) {
  const { __t } = useTranslation('SPRITE_SHEETS');
  const spriteProps = __t(name);

  const spritesheet = (
    <Spritesheet
      {...spriteProps}
      {...rest}
      getInstance={(spritesheet: any) => {
        ref.current = spritesheet;
        console.log('ref.current', ref.current);
      }}
    />
  );

  return {
    name,
    spritesheet,
    ref,
  };
}
